import formInputFieldPropsMixin from './formInputFieldProps';

export default {
  mixins: [formInputFieldPropsMixin],
  props: {
    type: {
      type: String,
      default: 'text',
    },
    max: {},
    min: {},
    step: {},
  },
};
